import styled, { css } from 'styled-components';

type FieldSize = 'sm' | 'md';

interface FieldProps {
  $hasError?: boolean;
  $fullWidth?: boolean;
  $size?: FieldSize;
}

export const FieldWrapper = styled.div<FieldProps>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.xs};
  width: ${props => (props.$fullWidth ? '100%' : 'auto')};
`;

export const FieldLabel = styled.label`
  font-size: ${props => props.theme.typography.sizes.sm};
  font-weight: ${props => props.theme.typography.weights.semibold};
  color: ${props => props.theme.colors.textSecondary};
`;

export const FieldInput = styled.input<FieldProps>`
  border-radius: ${props => props.theme.radii.md};
  border: 1px solid
    ${props =>
      props.$hasError ? props.theme.colors.danger : props.theme.colors.border};
  background: ${props => props.theme.colors.surface};
  padding: ${props =>
    props.$size === 'sm'
      ? `${props.theme.spacing.xs} ${props.theme.spacing.md}`
      : `${props.theme.spacing.sm} ${props.theme.spacing.md}`};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  min-height: ${props => (props.$size === 'sm' ? '36px' : '40px')};
  color: ${props => props.theme.colors.textPrimary};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: ${props => props.theme.colors.textMuted};
  }

  &:focus {
    outline: none;
    border-color: ${props =>
      props.$hasError ? props.theme.colors.danger : props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }

  ${props =>
    props.$hasError &&
    css`
      background: rgba(214, 69, 69, 0.04);
    `}
`;

export const HelperText = styled.span<FieldProps>`
  font-size: ${props => props.theme.typography.sizes.xs};
  line-height: ${props => props.theme.typography.lineHeights.xs};
  color: ${props =>
    props.$hasError ? props.theme.colors.danger : props.theme.colors.textMuted};
`;
